module.exports = __webpack_public_path__ + "img/76_31.f057c03f.png";